// ===============   BEGIN    Search result list
/**
 *
 */
const SearchType = {
  ALL: 'all',
  PRODUCT: 'product',
  COLLECTION: 'collection',
  ARTICLE: 'article',
  PAGE: 'page',
}

/**
 * search result list
 */
theme.SearchResList = (function () {
  const types = ['article', 'page']
  const typeConfig = {
    article: {
      container: 'search-results-article'
    },
    page: {
      container: 'search-results-page'
    }
  }

  function escapeHtml(str) {
    return (str??'').replace(/[&<>"']/g, function(match) {
        const escapeMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };
        return escapeMap[match];
    });
  }

  const loadPart = async (type, q, sectionId, page) => {
    let url = `/search?type=${type}&q=${encodeURIComponent(q)}&section-id=${sectionId}`
    if (page) {
      url += `&page=${page}`
    }
    const response = await fetch(url);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, "text/html");
    if (!html.querySelector('.search-content-empty')) {
      var resultHtml = html.querySelector('.search-results')
      if ($('.' + typeConfig[type].container).length) {
        $('.' + typeConfig[type].container).html(resultHtml.innerHTML)
      } else {
        $(`#${sectionId} .search-page-content`).append(`<div class="search-results ${typeConfig[type].container}">${resultHtml.innerHTML}</div>`)
      }
      return true
    }
    return false
  }

  return {
    init: async () => {
      var sectionId = $('.collection-container').closest('.shopify-section').attr('id')
      if ($('.search-content-empty').length) {
        return
      }
      var query = $.qs()
      if (query.q) {
        var q = query.q[0]
        var result
        for (const type of types) {
          var partResult = await loadPart(type, q, sectionId)
          if (!result) {
            result = partResult
          }
        }
        console.log(result)
        if (result) {
          $(`#${sectionId} .search-results`).on('click', '.page > a, .next > a', e => {
            e.preventDefault()
            var href = $(e.target).attr('href')
            if (href) {
              var sp = new URLSearchParams(href.split('?')[1])
              loadPart(sp.get('type'), sp.get('q'), sectionId, sp.get('page'))
            }
          })
        }
      }
    },
  }
})()

theme.predictiveSearch = (function () {
  var currentString = ''
  var isLoading = false
  var namespace = '.predictive'
  var isV2 = false

  var selectors = {
    form: '.site-header__search-form',
    formV2: '.site-header-predictive-search>form',
    input: 'input[type="search"]',
    wrapper: '#PredictiveWrapper',

    searchButton: '[data-predictive-search-button]',

    resultDiv: '.predictive-results-content',
    //resultTemplate: '#PredictiveTemplate',
  }

  // var resultTemplate

  var keys = {
    up_arrow: 38,
    down_arrow: 40,
    tab: 9,
  }

  function init() {
    // Only some languages support predictive search
    if (document.getElementById('shopify-features')) {
      var supportedShopifyFeatures = JSON.parse(
        document.getElementById('shopify-features').innerHTML
      )
      if (!supportedShopifyFeatures.predictiveSearch) {
        return
      }
    }

    // if (localStorage.getItem('menu-search') && localStorage.getItem('menu-search') == '2' && window.location.href.indexOf('/en-ca') == -1) {
    //   document.getElementById('header-menu-v2').classList.add('header-search-v2')
    //   isV2 = true
    // }

    // if (isV2) {
    //   $('.site-header-predictive-search').removeClass('hide')
    //   $('.site-header-predictive-search input').on('focus', function() {
    //     $('.site-header-predictive-search').addClass('active')
    //     requestAnimationFrame(() => {
    //       $('.predictive-search-layout').css('opacity', 1)
    //     })
    //   })
    //   $('.search-terms').on('click', '.search-terms-keyword .vegoicon-close-plain', function() {
    //     $(this).closest('.search-terms-keyword').hide()
    //   })
    //   $('.search-terms').on('click', '.search-terms-keyword', function() {
    //       if ($(this).css('display') !== 'none') {
    //           $('.site-header-predictive-search').find('input[name=q]').val($(this).text().trim())
    //           window.location.href = `${theme.routes.home!='/'?theme.routes.home:''}/search?type=product&q=`+$(this).text().trim()
    //         //setTimeout(()=> $('form.site-header__search-form [type="submit"]' ).click(),600)
    //       }
    //   })
    //   const forms = document.querySelectorAll(selectors.formV2)
    //   forms.forEach(form => {
    //     new PredictiveSearchForm(form, true)
    //   })
    // } else {
      $('.header-inline-top .js-search-trigger')?.removeClass('hide')
      $('.search-container,.search-form-item').on('click', '.search-terms-keyword .vegoicon-close-plain', function() {
        $(this).closest('.search-terms-keyword').hide()
      })
      $('.search-container,.search-form-item').on('click', '.search-terms-keyword', function() {
          if ($(this).css('display') !== 'none') {
              $('.search-container,.search-form-item').find('input[name=q]').val($(this).text().trim())
              window.location.href = `${theme.routes.home!='/'?theme.routes.home:''}/search?type=product&q=`+$(this).text().trim()
            //setTimeout(()=> $('form.site-header__search-form [type="submit"]' ).click(),600)
          }
      })
      // var source = document.querySelector(selectors.resultTemplate).innerHTML

      // resultTemplate = Handlebars.compile(source)
      const forms = document.querySelectorAll(selectors.form)
      forms.forEach(form => {
        new PredictiveSearchForm(form)
      })
    // }
  }

  class PredictiveSearchForm {
    constructor(element, v2) {
      this.isLoading = false
      this.isV2 = v2
      this.searchTimeout = null
      this.currentString = ''
      element.setAttribute('autocomplete', 'off')
      element.on('submit' + namespace, this.submitSearch)
      this.form = element
      this.input = element.querySelector(selectors.input)
      // try {
      //   this.input.value = this.input.getAttribute('placeholder')
      //   this.input.addEventListener('focusin', (evt) => {
      //     if (evt.target.value === this.input.getAttribute('placeholder')) {
      //       evt.target.value = ''
      //     }
      //   })
      //   this.input.addEventListener('focusout', (evt) => {
      //     if (evt.target.value === '') {
      //       evt.target.value = this.input.getAttribute('placeholder')
      //     }
      //   })
      // } catch (error) {
      //   console.log(`Handle Search Placeholder Error: `, error)
      // }
      this.input.on('paste' + namespace, this.handleKeyup.bind(this))
      this.input.on('input' + namespace, this.handleKeyup.bind(this))
      this.input.on('keyup' + namespace, this.handleKeyup.bind(this))
      if (element.closest('.search-layout')) {
        this.submit = element.closest('.search-layout').querySelector(selectors.searchButton)
        this.submit.on('click' + namespace, this.triggerSearch.bind(this))
        this.results = element.closest('.search-layout').querySelector(selectors.resultDiv)
        this.wrapper = element.closest('.search-layout').querySelector('.predictive-results')
      } else if (this.isV2) {
        this.submit = element.closest('.site-header-predictive-search').querySelector(selectors.searchButton)
        this.submit.on('click' + namespace, this.triggerSearch.bind(this))
        this.results = element.closest('.site-header-predictive-search').querySelector(selectors.resultDiv)
        this.wrapper = element.closest('.site-header-predictive-search').querySelector('.predictive-results')
      }
    }

    reset(empty) {
      this.wrapper.classList.add('hide')
      this.showDefaultLayout(empty)
      clearTimeout(this.searchTimeout)
    }

    triggerSearch() {
      this.form.submit()
    }

    submitSearch(evt) {
      evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false)

      var obj = {}
      var formData = new FormData(evt.target)
      for (var key of formData.keys()) {
        obj[key] = formData.get(key)
      }

      if (obj.q) {
        obj.q += '*'
      }

      var params = paramUrl(obj)

      window.location.href = window.route_prefix + "search?" + params;
      return false
    }

    handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        return
      }

      if (evt.keyCode === keys.down_arrow) {
        return
      }

      if (evt.keyCode === keys.tab) {
        return
      }
      this.search()
    }

    search() {
      var keyword = this.input.value

      if (keyword === '') {
        this.reset()
        return
      }

      var q = _normalizeQuery(keyword)

      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(
        function () {
          if (!theme.templates['template-search'].result) {
            theme.loadTemplate('template-search').then(result => {
              theme.templates['template-search'].result = result
              this.predictQuery(q)
            })
          } else {
            this.predictQuery(q)
          }
        }.bind(this),
        500
      )
    }

    hideDefaultLayout() {
      if (this.isV2) {
        this.form.closest('.site-header-predictive-search').querySelector('.search-terms').classList.add('hide')
        this.form.closest('.site-header-predictive-search').querySelector('.search-suggest-item').classList.add('hide')
      } else {
        this.form.closest('.search-layout').querySelector('.search-terms').classList.add('hide')
        this.form.closest('.search-layout').querySelector('.search-suggest-item').classList.add('hide')
        this.form.closest('.search-container')?.querySelector('.header-inline-nav-bottom ')?.classList.add('hide')
      }
    }

    showDefaultLayout(empty) {
      var layout = this.isV2 ?  this.form.closest('.site-header-predictive-search') : this.form.closest('.search-layout')
      if (empty) {
          layout.querySelector('.search-suggest-empty-result').innerHTML = `Sorry, no results for "${this.currentString}"`
          layout.querySelector('.search-suggest-empty-result').classList.remove('hide')
          layout.querySelector('.search-terms').classList.add('hide')
      } else {
        layout.querySelector('.search-terms').classList.remove('hide')
        layout.querySelector('.search-suggest-empty-result').classList.add('hide')
      }
      layout.querySelector('.search-suggest-item').classList.remove('hide')
      if (!this.isV2) {
        this.form.closest('.search-container')?.querySelector('.header-inline-nav-bottom ')?.classList.remove('hide')
      }
    }

    setKeyword(keyword) {
      if (this.isV2) {
        this.form.closest('.site-header-predictive-search').querySelector('.predictive-search-layout .predictive-keywords span').innerHTML = keyword
      } else {
        this.form.closest('.search-layout').querySelector('.predictive-keywords span').innerHTML = keyword
      }
    }

    setLoading() {
      var layout = this.isV2 ?  this.form.closest('.site-header-predictive-search').querySelector('.predictive-search-layout') : this.form.closest('.search-layout')
      if (this.isLoading) {
        layout.classList.add('is-loading')
      } else {
        layout.classList.remove('is-loading')
      }
    }

    predictQuery(q) {
      if (this.isLoading) {
        return
      }

      // Do not re-search the same thing
      if (this.currentString === q) {
        return
      }

      this.currentString = q
      this.setKeyword(q)

      this.isLoading = true
      this.setLoading()

      var searchObj = {
        q: q + '*',
        'resources[type]': 'product,page,query',
        'resources[limit]': 2000,
        // 'resources[options][unavailable_products]': 'last',
        // 'resources[options][fields]':
        //   'title,product_type,variants.title,vendor',
      }

      var params = paramUrl(searchObj)
      fetch(`${window.route_prefix}search/suggest.json?` + params)
        .then((response) => response.json())
        .then((suggestions) => {
          // if (window.location.pathname.startsWith('/en-ca') && suggestions.resources?.results?.products) suggestions.resources.results.products = suggestions.resources.results.products.map(item => {
          //   return ['vego-garden-6-in-1-modular-raised-garden-bed-kit',
          //     '9-in-1-modular-raised-garden-bed',
          //     '10-in-1-modular-metal-raised-garden-bed-kit',
          //     '32-extra-tall-6-in-1-modular-raised-garden-bed-kit',
          //     '32-extra-tall-9-in-1-modular-raised-garden-bed-kit',
          //     '32-extra-tall-10-in-1-modular-raised-garden-bed-kit'].includes(item.handle)
          // })
          this.isLoading = false;
          this.setLoading();
          var data = {};
          var resultCount = 0;

          this.wrapper.classList.remove("hide");
          var resultTypes = Object.entries(suggestions.resources.results);

          Object.keys(resultTypes).forEach((i) => {
            var obj = resultTypes[i];
            var type = obj[0];
            var results = obj[1];
            results.count = obj[1].length;
            resultCount += results.length;

            switch (type) {
              case "products":
                data[type] = this.buildProducts(results);
                break;
              case "collections":
                data[type] = this.buildCollections(results);
                break;
              default:
                data[type] = this.parseResultImages(results);
                break;
            }
          });

          if (resultCount === 0) {
            this.reset(true);
            return;
          }

          // Append result markup
          this.results.innerHTML = "";
          // data.articles.forEach(item => {
          //   item.tags = item.tags.map(tag => {
          //     return {
          //       tag: tag,
          //       handle: tag.toLowerCase().replace(/ /ig, '-'),
          //       category: item.url.split('/')[2],

          //     }
          //   })
          // })
          data.queries.forEach((item) => {
            item.styled_text = item.styled_text.replace(q, "<b>" + q + "</b>");
          });
          this.results.innerHTML =
            theme.templates["template-search"].result(data);
          // this.results.innerHTML = resultTemplate(data)
          this.hideDefaultLayout();

          // const numberArr = [$('[data-type-products] [data-type="product"]').length,$('[data-type-articles] [data-type="article"]').length,$('[data-type="collection"]').length,$('[data-type="page"]').length]
          $(`[href*="do-not-ship-item"]`).closest(".grid-product").remove();
          if ($(`.predictive-product>div`).length == 0) {
            $(`.predictive-product`).remove();
            $(`[data-title="product"]`).closest(".search-title-box").remove();
          }
          $(".search-inner-heading").map((index, item) => {
            const type = $(item).data("title");
            console.log($(item));
            if (type) {
              const len = $(
                `[data-type-${type}] [data-type="${type}"]:not(:empty)`
              ).length;
              $(item).html(`${$(item).text()}(${len})`);
            }
          });

          /**
           * more link action
           */
          $(".search-btn-more a").click((e) => {
            e.stopPropagation();
            const title = $(e.target).data("title");
            $('[role="search"] [name="datatype"]').val(title);
            //simulate submit
            $('[role="search"] [type="submit"]').eq(0).click();
          });
        });
    }

    hightText(text) {
      const regex = new RegExp("(" + this.currentString + ")", "gi")
      return text.replace(regex, `<mark>$1</mark>`)
    }

    buildProducts(results) {
      var products = []

      results.forEach((product) => {
        var new_product = {
          title: this.hightText(product.title),
          url: product.url,
          image: theme.Images.srcSetImages(product.image),
          vendor: product.vendor,
          price: theme.Currency.formatMoney(product.price),
          compare_price_max: theme.Currency.formatMoney(
            product.compare_at_price_max
          ),
          on_sale:
            parseInt(product.compare_at_price_max) > parseInt(product.price),
        }

        products.push(new_product)
      })

      return products.slice(0, 5)
    }

    buildCollections(results) {
      var collections = []

      results.forEach((collection) => {
        var new_collection = {
          title: collection.title,
          url: collection.url,
        }

        if (collection.featured_image.url) {
          new_collection.image = theme.Images.getSizedImageUrl(
            collection.featured_image.url,
            '200x200_crop_center'
          )
        }

        collections.push(new_collection)
      })

      return collections
    }

    parseResultImages(results) {
      results.forEach((result) => {
        if (result.image) {
          var image = theme.Images.getSizedImageUrl(
            result.image,
            '200x200_crop_center'
          )
          result.image = image
        }
        if (result.title) {
          result.title = this.hightText(result.title)
        }
      })

      return results
    }
  }

  function _normalizeQuery(string) {
    if (typeof string !== 'string') {
      return null
    }

    return string.trim()
  }

  function paramUrl(obj) {
    return Object.keys(obj)
      .map(function (key) {
        return key + '=' + encodeURIComponent(obj[key])
      })
      .join('&')
  }

  return {
    init: init,
  }
})()




if (DOMready) {
  DOMready(() => {
    theme.SearchResList.init()
    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch?.init?.()
    }
  })
} else {
  theme.SearchResList.init()
}